import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AppToastService } from './shared/services/app-toast.service';

import {
  Component,
  OnInit,
  Inject,
  Renderer2,
  ElementRef,
  ViewChild,
  DOCUMENT,
} from '@angular/core';
import { Router, NavigationEnd, NavigationError } from '@angular/router';
// REMOVIDO: import { Subscription } from 'rxjs/Subscription';
// REMOVIDO: import 'rxjs/add/operator/filter';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth.service';
import { TenantService } from './core/services/tenant.service';
import './shared/extensions/observable.extension';
import { UserFromLoginDto } from './core/models/dto/user-from-login-dto';
import { UserToReturnDto } from './core/models/dto/user-to-return-dto';
import { ErrorAlertService } from './core/services/error-alert.service';
import { getStoredToken, getStoredUser } from './core/utils/auth-storage';
import { AppUpdateService } from './core/services/app-update.service';

interface ValidationError {
  [key: string]: string[];
}

const CHUNK_LOAD_ERROR_REGEX =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk/i;
const CHUNK_RELOAD_SESSION_KEY = 'cs-chunk-reload';
const CHUNK_RELOAD_COOLDOWN_MS = 10000;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'connectsea-web';

  users: any;
  // jwtHelper = new JwtHelperService();

  // tslint:disable-next-line: variable-name
  private _router: Subscription;

  showCustomAlert = false;
  errorMessages: ValidationError = {};

  Object: any;

  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private tenantService: TenantService,
    public router: Router,
    @Inject(DOCUMENT)
    private document: any,
    private element: ElementRef,
    private toastService: AppToastService,
    public location: Location,
    private errorAlertService: ErrorAlertService,
    private titleService: Title,
    private appUpdateService: AppUpdateService,
  ) {
    this.titleService.setTitle(environment.appTitle);
  }

  getErrorFields(): string[] {
    return Object.keys(this.errorMessages);
  }

  onAlertClosed() {
    this.showCustomAlert = false;
  }

  ngOnInit(): void {
    if (this.tenantService.isHmgEnvironment()) {
      this.document.body.classList.add('is-hmg-env');
    }

    var self = this;

    // Monkey-patch do Observable (legacy)
    Observable.prototype.subscribeWithErrorHandling = function (
      this: Observable<any>,
      nextFunc: (response: any) => void,
    ): void {
      this.subscribe({
        next: (action) => nextFunc(action),
        error: () => {},
      });
    };

    this.errorAlertService.showCustomAlert$.subscribe((show) => {
      this.showCustomAlert = show;
      // Ocultar o alerta após 10 segundos
      if (this.showCustomAlert) {
        setTimeout(() => {
          this.showCustomAlert = false;
        }, 10000); // 10000 milissegundos = 10 segundos
      }
    });

    this.errorAlertService.errorMessages$.subscribe((messages: any) => {
      this.errorMessages = messages;
    });

    this.setCurrentUser();
    this.appUpdateService.initialize();

    // Lógica de resetar o scroll ao trocar de rota (ATUALIZADA COM PIPE)
    this._router = this.router.events
      .pipe(
        // ATUALIZADO: Usando pipe e tipando event como 'any' para evitar erro TS7006
        filter((event: any) => event instanceof NavigationEnd),
      )
      .subscribe((event: NavigationEnd) => {
        if (window.outerWidth > 991) {
          window.document.children[0].scrollTop = 0;
        } else {
          if (window.document.activeElement !== null) {
            window.document.activeElement.scrollTop = 0;
          }
        }
      });

    // Após um novo deploy, uma aba já aberta pode tentar buscar um chunk
    // lazy-loaded com hash antigo (removido do servidor). Isso derruba a
    // navegação silenciosamente (sem exceção visível), travando links até
    // um F5 manual. Detecta o erro e força um reload real na URL de destino.
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationError))
      .subscribe((event: NavigationError) => {
        if (!CHUNK_LOAD_ERROR_REGEX.test(event.error?.message ?? '')) {
          return;
        }

        const lastReload = sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY);
        const now = Date.now();
        if (lastReload && now - Number(lastReload) < CHUNK_RELOAD_COOLDOWN_MS) {
          console.error(
            '[ChunkLoadError] reload já tentado recentemente, abortando para evitar loop.',
            event.error,
          );
          return;
        }

        sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, String(now));
        window.location.href = event.url;
      });
  }

  setCurrentUser() {
    const userString = getStoredUser();
    const tokenString = getStoredToken();

    if (!userString) return;

    const userStored: UserToReturnDto = JSON.parse(userString);
    const user: UserFromLoginDto = {
      token: tokenString,
      user: userStored,
    };
    this.authService.setCurrentUser(user);
  }
}
